export const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://vioo.vip' : 'http://localhost:3000'
export const API_URL = process.env.NODE_ENV === 'production' ? 'https://vioo.vip/api' : 'http://localhost:8000/api'
// export const API_URL = 'https://vioo.vip/api'
export const TIKTOK_PLAYER_LINK_PREFIX = 'https://www.tiktok.com/player/v1/'
export const PROMOTION_VIDEO_URL = 'https://www.tiktok.com/player/v1/7522355523543469319'